<template>
  <div>
    <Modal
      title="选择部门"
      v-model="modalVisible"
      :mask-closable="false"
      @on-cancel="beforeClose"
      :closable="false"
      width="1000"
    >
      <Tree
        ref="treeRef"
        class="demo-tree-render"
        :data="treeData"
        :show-checkbox="true"
        :render="renderContent"
        :check-strictly="true"
      />
      <!-- @on-select-change="onSelectChange"-->
      <!-- @on-check-change="onCheckChange"-->
      <!-- :check-strictly="true"-->
      <span slot="footer" class="dialog-footer">
        <Button @click="beforeClose">取 消</Button>
        <Button type="primary" @click="submit">确 定</Button>
      </span>
      <Spin size="large" fix v-if="loading"></Spin>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import modalMixins from '@/mixins/modalMixins';
export default {
  mixins: [modalMixins],
  name: 'SelectDepartment',
  data() {
    return {
      loading: false,
      treeData: [],
      originDepartmentData: [],
      currentDepartSelectIds: [],
      firstDepSelectIds: [], // 第一次进来时的idList
      buttonProps: {
        type: 'default',
        size: 'small'
      },
      treeMapData: new Map()
    };
  },
  methods: {
    ...mapActions('characterManage', ['getDepartmentInfo']),
    beforeClose () {
      // 判断是否有过修改，就提示
      const currentDepartSelectIds = this.$refs.treeRef.getCheckedNodes().map(i => i.relationId);
      if (this.isChange(this.firstDepSelectIds, currentDepartSelectIds)) {
        this.$Modal.confirm({
          title: '提示',
          content: '存在已经选择的部门，是否保存?',
          onCancel: () => {
            this.cancelModal();
          },
          onOk: () => {
            this.submit();
          }
        });
      } else {
        this.cancelModal();
      }
    },
    isChange (firstData, currentData) {
      if (firstData.length !== currentData.length) return true;
      return !currentData.every(item => firstData.includes(item));
    },
    modalInit() {
      this.loading = true;
      this.getDepartmentInfo({ selectedIds: this.selectList }).then(res => {
        this.loading = false;
        const { originData, treeData, treeMapData } = res;
        this.originDepartmentData = originData;
        this.treeMapData = treeMapData;
        this.setTreeData(treeMapData, this.selectList);
        this.treeData = treeData;
        this.firstDepSelectIds = [...this.selectList];
        this.currentDepartSelectIds = [...this.selectList];
      }, () => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    async submit() {
      // currentDepartSelectIds 当前选择的
      // const selDepartRelList = [...this.currentDepartSelectIds];
      const selDepartRelList = this.$refs.treeRef.getCheckedNodes().map(i => i.relationId);
      // 删除的
      const delSelDepartRelList = (this.originData.selDepartRelList || []).filter(id => !selDepartRelList.includes(id));
      this.$emit('on-submit', { selDepartRelList: [...selDepartRelList], type: this.type, delSelDepartRelList, allDepartRelList: [...selDepartRelList] });
      this.cancelModal();
    },
    onSelectChange () {
      console.log('onSelectChange');
    },
    onCheckChange (arr, changeItem) {
      const isDelete = !changeItem.checked;
      if (isDelete) {
        this.currentDepartSelectIds = [...this.currentDepartSelectIds.filter(id => id !== changeItem.relationId)];
      } else {
        this.currentDepartSelectIds.push(changeItem.relationId);
      }
      if (changeItem.pid && changeItem.parentNode) {
        this.setParentStatus({
          changeItem: changeItem.parentNode,
          isDelete,
          idListName: 'currentDepartSelectIds',
          idName: 'relationId'
        });
      }
      // 如果是有子节点的话，并且选择删除的时候，把子节点的给取消掉
      if (changeItem.children && changeItem.children.length > 0) {
        this.changeChildrenNode({
          children: changeItem.children,
          isDelete,
          idName: 'relationId',
          idListName: 'currentDepartSelectIds'
        });
      }
      // this.checkSelectDepartmentSelectdIdChangeRowDepartmentStatus();
    },
    setParentStatus({ changeItem, isDelete, idListName, idName }) {
      const { children } = changeItem;
      if (children && children.length) {
        if (children.every(item => !item.checked)) {
          changeItem.checked = false;
          this[idListName] = [...this[idListName].filter(i => i !== changeItem[idName])];
        } else {
          changeItem.checked = true;
          this[idListName] = [...this[idListName], changeItem[idName]];
        }
      }
      if (changeItem.pid && changeItem.parentNode) {
        this.setParentStatus({ changeItem: changeItem.parentNode, isDelete, idListName, idName });
      }
    },
    changeChildrenNode({ children, isDelete, idListName, idName }) {
      children.forEach(item => {
        if (isDelete) {
          this[idListName] = [...this[idListName].filter(i => i !== item[idName])];
        } else {
          this[idListName] = [...this[idListName], item[idName]];
        }
        item.checked = !isDelete;
        if (item.children && item.children.length > 0) {
          this.changeChildrenNode({
            children: item.children,
            isDelete,
            idListName,
            idName
          });
        }
      });
    },
    renderContent (h, { root, node, data }) {
      const extraBtn = [];
      if (data.children && data.children.length > 0) {
        extraBtn.push(
          h('Button', {
            props: Object.assign({}, this.buttonProps, { type: 'success' }),
            style: {
              marginRight: '8px'
            },
            on: {
              click: (e) => {
                e.stopPropagation();
                this.changeCheck(data, true);
              }
            }
          }, '全选'),
          h('Button', {
            props: Object.assign({}, this.buttonProps, { type: 'error' }),
            on: {
              click: (e) => {
                e.stopPropagation();
                this.changeCheck(data, false);
              }
            }
          }, '反选')
        );
      }
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%',
          color: data.hasChecked ? 'red' : ''
        }
      }, [
        h('span', data.title),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '32px'
          }
        }, extraBtn)
      ]);
    },
    changeCheck (array, boolean) {
      // 将下级的选中
      // 如果下级还有子集，那么也将字集也都选中
      function check(arr) {
        arr.children.forEach(item => {
          item.checked = boolean;
          if (item.children && item.children.length > 0) {
            check(item);
          }
        });
      }
      check(array);
    },
    setTreeData (treeMapData, selectIds) {
      const newList = selectIds.map(id => {
        return treeMapData.get(id);
      }).filter(Boolean);
      while (newList.length > 0) {
        const obj = newList[0];
        newList.shift();
        if (obj.parentNode) {
          newList.push(obj.parentNode);
        }
        obj.hasChecked = true;
      }
    }
  },
  props: {
    selectList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    },
    originData: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    this.modalInit();
  }
};
</script>

<style>
.demo-tree-render .ivu-tree-title{
  width: calc(100% - 12px - 8px - 16px);
}
</style>
